export const PRODUCTS = {
  laEsperanza: 'la-esperanza-001'
};

export const CART = {
  openButton: 'cart-open-button',
  drawer: 'cart-drawer',
  emptyMessage: 'cart-empty-message',
  itemsList: 'cart-items-list',
  totalAmount: 'cart-total-amount',
  checkoutButton: 'cart-checkout-button',
  closeButton: 'cart-close-button',
  removeItemButton: 'cart-remove-item-button'
};

export const HEADER = {
  logo: 'header-logo',
  navigation: 'header-navigation',
  cartIcon: 'header-cart-icon',
  cartBadge: 'header-cart-badge'
};

export const PRODUCT = {
  card: 'product-card',
  name: 'product-name',
  price: 'product-price',
  description: 'product-description',
  image: 'product-image',
  addToCartButton: 'product-add-to-cart-button',
  quantityInput: 'product-quantity-input',
  tastingNotes: 'product-tasting-notes'
};

export const HERO = {
  section: 'hero-section',
  title: 'hero-title',
  subtitle: 'hero-subtitle',
  ctaButton: 'hero-cta-button'
};

export const ABOUT = {
  section: 'about-section',
  title: 'about-title',
  content: 'about-content'
};

export const FOOTER = {
  section: 'footer-section',
  socialLinks: 'footer-social-links',
  contactEmail: 'footer-contact-email'
};

export const PAYMENT = {
  successPage: 'payment-success-page',
  cancelPage: 'payment-cancel-page',
  statusMessage: 'payment-status-message'
};
